import QWebChannel from '@/utils/qwebchannel.js'
// type: 'ReadIDCard'
// params: {
//   ationtype: 'read'
// }
export const qw = (type, params, CallBackData) => {
  console.log('进入 qw')
  let wsUri = 'ws://localhost:11303'
  let channelMQ = null
  let rqData = {
    uuid: '56928717636',
    data: {
      CallBackData,
      type,
      version: 'apollo',
      params
    }
  }
  const promise = new Promise(function(resolve, reject) {
    const socket = new WebSocket(wsUri)
    socket.onclose = function() {
      console.error('web channel closed')
    }
    socket.onerror = function(error) {
      console.error('web channel error: ' + error)
    }
    socket.onopen = function() {
      console.log('open.....')
      let q = new QWebChannel(socket, function(channel) {
        channelMQ = channel.objects.ChannelMQ
        channelMQ.SendMessageToQT(JSON.stringify(rqData)) // 发送消息
        channelMQ.SendMessageToWeb.connect(str => {
          let data = JSON.parse(str)
          if (data.code === '1000') {
            console.log('qw success')
            if (data.data) {
              resolve(data.data)
            } else {
              resolve(data.hardDeviceInfo)
            }
          } else {
            console.log('qw error')
            reject(str)
          }
        })
      })
    }
  })
  return promise
}



// WEBPACK FOOTER //
// ./src/utils/qw.js